import { render } from "./ConfirmTeamUserRemoveDialog.vue?vue&type=template&id=bfa0e27c"
import script from "./ConfirmTeamUserRemoveDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmTeamUserRemoveDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__